module.exports = __webpack_public_path__ + "img/hmi-cross.769bddd6.webp";